import { render, staticRenderFns } from "./ProductComponents.vue?vue&type=template&id=4ce9dd35&"
import script from "./ProductComponents.vue?vue&type=script&lang=ts&"
export * from "./ProductComponents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports